import { ACTIONS } from '@~/actions/snackbar';

const initialState = {
  duration: null,
  message: null,
  visible: false,
  type: 'success',
};

export default function defaultExport(state = initialState, { type, payload }) {
  switch (type) {
    case ACTIONS.SHOW_SNACKBAR: {
      return {
        ...payload,
        visible: true,
      };
    }
    case ACTIONS.HIDE_SNACKBAR: {
      return initialState;
    }
    default:
      return state;
  }
}
